export type InvoiceInformationItem = 'payment_email' | 'banking_contact' | 'mailing_address';
export interface InvoiceInformationResponse {
  invoiceId: number;
  jobId: number;
  canRequest: boolean;
  practiceName: string;
  talentFirstName: string;
  shiftDate: string;
  paymentEmailLabel: string;
  serverNow: string;
  request: null | {
    requestId: number; generation: number; item: Exclude<InvoiceInformationItem, 'mailing_address'>;
    status: 'awaiting_response' | 'shared' | 'expired' | 'contact_requested';
    requestedOn: string; sharedOn: string | null; expiresOn: string | null; acknowledgedOn: string | null;
    canAskAgain: boolean; paymentEmail?: string; savedPaymentEmail?: string;
  };
  history?: Array<{id: number; generation: number; fieldName: string; paymentEmail: string; sharedOn: string; expiresOn: string; dentistId: number; locationId: number}>;
}
export interface InvoiceInformationMutation {
  invoiceId: number;
  accepted?: boolean;
  acknowledged?: boolean;
  alreadyShared?: boolean;
  kind?: InvoiceInformationItem;
  message?: string;
  requestId?: number;
  generation?: number;
}

export function informationDisplayDuration(value: InvoiceInformationResponse) {
  if (!value.request?.expiresOn || value.request.status !== 'shared') return 0;
  return Math.max(0, Date.parse(value.request.expiresOn) - Date.parse(value.serverNow));
}
